import React from "react";
import Portfolio from "../../componets/Portfolio";

const Section1 = () => {
  return (
    <div className="w-full h-[30vh] xl:h-[60vh] Section1">
      <Portfolio
        bgImage={"/assets/web-banner-career-1.jpg"}
        objectPosition={"center-center"}
        customer={false}
        altText="Case Studies Background Image"
        headertext="FOR HUNDREDS OF SUCCESSFUL BUISNESSES WORLDWIDE"
        showPortfolioBtn={false}
      />
    </div>
  );
};

export default Section1;
